import { Sparkles } from "lucide-react";
import { Reveal } from "./motion";
import { IOL_TYPES } from "../lib/constants";

export const CataractServices = () => (
  <div data-testid="cataract-services">
    <Reveal>
      <div className="rounded-3xl bg-ink text-white noise-dark relative overflow-hidden p-8 sm:p-12">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: "radial-gradient(70% 90% at 90% 0%, rgba(6,182,212,0.2), transparent 60%)" }}
        />
        <div className="relative">
          <span className="kicker !text-aqua-bright">The Procedure</span>
          <h3 className="mt-4 text-2xl sm:text-3xl font-extrabold tracking-tight leading-tight">
            Micro-Incisional Sutureless Cataract Surgery (MICS)
            <span className="block mt-2 font-serif italic font-semibold text-aqua-bright text-xl sm:text-2xl">
              with Premium Intra-Ocular Lenses
            </span>
          </h3>
          <p className="mt-5 text-blue-100/85 leading-relaxed max-w-2xl text-sm sm:text-base">
            Modern cataract surgery at iNetra is performed through a very small incision that typically needs no
            stitches. The cloudy natural lens is gently removed and replaced with a clear artificial lens (IOL),
            selected together with you based on your eyes and lifestyle.
          </p>
        </div>
      </div>
    </Reveal>
    <div className="mt-6 grid gap-5 md:grid-cols-3">
      {IOL_TYPES.map((iol, i) => (
        <Reveal key={iol.name} delay={i * 0.1}>
          <div className="card-lift h-full rounded-2xl border border-slate-200 bg-white p-7" data-testid={`iol-card-${i}`}>
            <div className="w-11 h-11 rounded-xl bg-aqua-mist flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-aqua" strokeWidth={1.7} aria-hidden="true" />
            </div>
            <h4 className="mt-4 text-lg font-extrabold text-ink">{iol.name}</h4>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{iol.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>
    <Reveal delay={0.2}>
      <p className="mt-6 text-xs text-slate-500 leading-relaxed max-w-3xl">
        Every eye is different. Dr. Vikas will recommend the lens option best suited to your eye measurements, visual
        needs and budget after a detailed evaluation — with honest guidance on what each lens can and cannot do.
      </p>
    </Reveal>
  </div>
);
